import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './index.module.scss'

/**
 * Visual-only voice channel (dual-channel identity). The wave + status are
 * always present; capture/transmit is not wired until the backend audio
 * (binary-frame) slice ships, so this stays in the idle state for v1.
 */
const WAVE_BARS = Array.from({ length: 16 })

const VoicePanel: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.voiceArea}>
      <div className={styles.vaViz}>
        <div className={styles.vaWave}>
          {WAVE_BARS.map((_, i) => (
            <i key={i} />
          ))}
        </div>
      </div>
      <div className={styles.vaState}>{t('genAI.copilot-voice-ready')}</div>
    </div>
  )
}

export default VoicePanel
